import BaseService from "../../BaseService";

export default class ZVVEinladungService extends BaseService {

  constructor(id) {
    super(`zvv/${id}/einladung`);
  }
}
